import { useQuery } from "@tanstack/react-query";

import { CardProps } from "@/components/Connections/ConnectionCard";
import { apiFetchJson } from "@/utils/apiFetch";

/**
 * Tenant-level data connections, one entry per distinct datasource, read
 * from the tenant schema's data_connection rows (seeded per client by the
 * backend's seed_data_connections command).
 */
export function usePortfolioConnectionsQuery() {
  return useQuery<CardProps[]>({
    queryKey: ["portfolio-connections"],
    queryFn: () =>
      apiFetchJson<CardProps[]>(
        `${import.meta.env.VITE_API_URL}/data/portfolio/portfolio-connections/`,
      ),
    staleTime: 5 * 60 * 1000,
  });
}
